// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3nnVi","checkboxCol":"Table_checkboxCol__2pFqO","emailCol":"Table_emailCol__1RMsH","actionCol":"Table_actionCol__2fAvC"};